import { useState, useRef } from 'react';
import { View, Text, StyleSheet, StyleProp, ViewStyle } from 'react-native';
import { theme } from '@socrait/react';

type TooltipProps = {
  tooltipContent: string | React.ReactNode;
  containerStyle?: StyleProp<ViewStyle>;
};

export function Tooltip({ tooltipContent, containerStyle }: TooltipProps) {
  const [isVisible, setIsVisible] = useState(false);
  const hideTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const show = () => {
    if (hideTimeoutRef.current) clearTimeout(hideTimeoutRef.current);
    setIsVisible(true);
  };

  const scheduleHide = () => {
    hideTimeoutRef.current = setTimeout(() => setIsVisible(false), 150);
  };

  return (
    <View style={styles.wrapper}>
      <View style={styles.trigger} onMouseEnter={show} onMouseLeave={scheduleHide}>
        <Text style={styles.triggerText}>?</Text>
      </View>
      {isVisible && (
        <View
          style={[styles.tooltip, containerStyle]}
          onMouseEnter={() => {
            if (hideTimeoutRef.current) clearTimeout(hideTimeoutRef.current);
          }}
          onMouseLeave={scheduleHide}>
          {typeof tooltipContent === 'string' ? <Text style={styles.text}>{tooltipContent}</Text> : tooltipContent}
        </View>
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  wrapper: {
    position: 'relative',
    overflow: 'visible',
  },
  trigger: {
    width: 18,
    height: 18,
    borderRadius: 9,
    borderWidth: 1,
    borderColor: theme.colors.darkGray,
    alignItems: 'center',
    justifyContent: 'center',
  },
  triggerText: {
    fontSize: theme.fontSizes.xsmall,
    color: theme.colors.darkGray,
  },
  tooltip: {
    position: 'absolute',
    top: '100%',
    left: 0,
    marginTop: theme.spacing.xsmall,
    zIndex: 1000,
    width: 240,
    backgroundColor: theme.colors.white,
    borderRadius: theme.borderRadius.medium,
    borderWidth: 1,
    borderColor: theme.colors.gray,
    padding: theme.spacing.medium,
    shadowColor: theme.colors.navy,
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.12,
    shadowRadius: 8,
  },
  text: {
    fontSize: theme.fontSizes.xsmall,
  },
});
